import { render, staticRenderFns } from "./SideWidgetUserProfileCalendar.vue?vue&type=template&id=adf9e928&"
import script from "./SideWidgetUserProfileCalendar.vue?vue&type=script&lang=js&"
export * from "./SideWidgetUserProfileCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SideWidgetUserProfileCalendar.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports